<div class="container-fluid">

  <div class="pageheader d-flex align-items-center justify-content-between mb-2">
    <h4 class="d-flex align-items-center mb-1">Consultants</h4>
  </div>

  <app-card>
    <div class="d-flex justify-content-end mb-2">
      <button type="button" class="btn btn-success btn-sm" (click)="addConsultant()" *ngIf="authService.canAdminConsultants()">
        <fa-icon [icon]="faPlus" class="me-1"></fa-icon>
        Add Consultant
      </button>
    </div>

    <app-table
      [columns]="columns"
      [data]="consultants"
      [totalCount]="resultsLength"
      [pageSize]="20"
      [loading]="isLoadingResults"
      [clickableRows]="authService.canAdminConsultants()"
      [initialFilterValues]="{ active: '{{bool}}true' }"
      (searchChange)="onSearch($event)"
      (rowClick)="editConsultant($event)">

      <ng-template tableCell="active" let-row>
        <span class="badge" [ngClass]="row.active ? 'bg-success' : 'bg-danger'">
          {{ row.active ? 'Active' : 'Inactive' }}
        </span>
      </ng-template>

      <ng-template tableCell="fees" let-row>
        {{ row.fees ? row.fees : '-' }}
      </ng-template>

    </app-table>
  </app-card>
</div>